import { render, staticRenderFns } from "./StockSlipLending.vue?vue&type=template&id=4561db66&scoped=true"
import script from "./StockSlipLending.vue?vue&type=script&lang=js"
export * from "./StockSlipLending.vue?vue&type=script&lang=js"
import style0 from "./StockSlipLending.vue?vue&type=style&index=0&id=4561db66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4561db66",
  null
  
)

export default component.exports